/**
 * Entrance motion — contract C4. ONE IntersectionObserver for the whole
 * theme, threshold 0.15 (D14), reveal once, then unobserve. The hidden
 * initial state only applies under html.js (base-styles), so content is
 * fully visible with zero JS. Reduced motion: css-variables zeroes the
 * duration tokens — no logic needed here.
 */
(() => {
  if (window.__bunzFadeUp) return;
  window.__bunzFadeUp = true;

  const reveal = (el) => el.classList.add('is-visible');
  const targets = () => document.querySelectorAll('.fade-up:not(.is-visible)');

  if (!('IntersectionObserver' in window)) {
    targets().forEach(reveal);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15 }
  );

  const observeAll = () => targets().forEach((el) => io.observe(el));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
  // content swapped in later (the filters, facets.js) has not been observed
  document.addEventListener('bunz:content-updated', observeAll);
})();
